import apiService from "./apiService";
import AppConstants from "../appConstants";

class DemoRequestService {
    getall(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_DEMOREQUEST, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    getTotalDemoRequest(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_TOTAL_DEMOREQUEST, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    getReportByDate(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_DEMOREQUEST_REPORT_DATE, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    report(params) {
        return new Promise((resolve, reject) => {
            apiService.downloadFile(AppConstants.URL_DEMOREQUEST_REPORT, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }
    
    // =====================================================================
    
}

export default new DemoRequestService();
